<div class="card" style="height: 100%">
  <div class="content-header" style="padding-top: 0; margin-left: 5px">Activity</div>
  <div class="flex" style="align-items: center; height: 100%">
    <div style="width: 100px; padding-left: 5px; height: 100%; margin-top: 30px">
      <div style="font-size: 14px; color: #808080">
        <div>Total Orders</div>
      </div>
      <div style="font-size: 32px; font-weight: 500; margin-top: 10px">
        {{ activity?.totalOrders }}
      </div>
    </div>
    <div style="max-width: 400px">
      <div style="display: grid; grid-template-columns: 150px 1fr; grid-gap: 5px">
        <div class="grid-label">Same day on-time:</div>
        <div class="grid-value">{{ activity?.sameDayOnTime }}% of Orders</div>
        <div class="grid-label">Completed Last Week:</div>
        <div class="grid-value">{{ activity?.ordersCompleteWeek }} Orders</div>
        <div class="grid-label">Completed This Month:</div>
        <div class="grid-value">{{ activity?.ordersCompleteMonth }} Orders</div>
        <div class="grid-label">Cancelled Last Week:</div>
        <div class="grid-value">{{ activity?.jobsCancelledWeek }} Orders</div>
        <div class="grid-label">Cancelled This Month:</div>
        <div class="grid-value">{{ activity?.jobsCancelledMonth }} Orders</div>
      </div>
    </div>
  </div>
</div>
